import { toast } from 'sonner';
import { toAppError } from './toAppError';

/**
 * Normalizes any thrown value and displays a Sonner error toast.
 * Centralizes toast copy so error messages are consistent across the app.
 * The <Toaster> (from shared-ui) must be mounted in the app root for toasts to render.
 */
export function showErrorToast(error: unknown): void {
    const appError = toAppError(error);
    toast.error(appError.title, { description: appError.message });
}
